import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import { Capacitor } from '@capacitor/core'

const apiKey = import.meta.env.VITE_BUGSNAG_API_KEY as string | undefined

function getReleaseStage(): string {
  if (import.meta.env.DEV) return 'development'
  const hostname = window.location.hostname
  if (hostname.includes('staging') || hostname.includes('develop') || hostname.includes('vercel.app')) {
    return 'staging'
  }
  return 'production'
}

function getAppType(): string {
  if (Capacitor.isNativePlatform()) {
    return `capacitor-${Capacitor.getPlatform()}`
  }
  return 'web'
}

if (apiKey) {
  Bugsnag.start({
    apiKey,
    plugins: [new BugsnagPluginReact()],
    releaseStage: getReleaseStage(),
    enabledReleaseStages: ['production', 'staging'],
    appVersion: (import.meta.env.VITE_APP_VERSION as string) || '1.0.0',
    appType: getAppType(),
    enabledBreadcrumbTypes: ['error', 'log', 'navigation', 'request', 'user'],
    redactedKeys: ['Authorization', 'token', /password/i],
    onError: (event) => {
      event.addMetadata('app', {
        platform: getAppType(),
        apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
      })
    },
  })
}

export default Bugsnag
